import React from 'react'
import { useMutation } from '@tanstack/react-query'

import { api } from '../lib/api'

// Shown on every signed-in page until the address is proven.
//
// Nothing in the app is gated on confirming — the funnel from sign-up to a
// first evaluation is the product, and putting a wall in it to protect against
// a typo would cost far more than the typo does. This is therefore the whole
// enforcement mechanism, which is why it is persistent rather than dismissible:
// the two messages that depend on the address being real, the pre-renewal
// reminder and the password reset, are both ones nobody misses until they
// suddenly need them.
export default function ConfirmEmailBanner({ email }) {
  const resend = useMutation({ mutationFn: () => api.resendConfirmation() })

  return (
    <div className="border-b border-amber-900 bg-amber-950/40">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2 px-3 py-2 sm:px-4">
        <p className="text-xs text-amber-200">
          {resend.isSuccess ? (
            <>A new confirmation link is on its way to {email}. It is good for two days.</>
          ) : (
            <>
              Confirm {email} so we can reach you about your account — a password reset, or
              the notice before a subscription renews.
            </>
          )}
        </p>

        <div className="flex items-center gap-3">
          {resend.error && (
            <span role="alert" className="text-xs text-rose-300">
              {resend.error.message}
            </span>
          )}

          {!resend.isSuccess && (
            <button
              type="button"
              onClick={() => resend.mutate()}
              disabled={resend.isPending}
              className="text-xs font-medium text-amber-200 underline disabled:opacity-60"
            >
              {resend.isPending ? 'Sending…' : 'Resend the link'}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
